import React from 'react';

import * as S from '../styled';
import ItemIcon from '../ItemIcon';

type Item = {
  id?: number,
  link?: string,
  icon?: string,
  name: string,
};

type Props = {
  to: string,
  level?: number,
  icon?: string,
  name: string,
  badge: string,
  isOpen: boolean,
  isFolder: boolean,
  selected: boolean,
  items: Item[],
  setOpen: { (): void },
};

const SidebarItem = ({
  to,
  icon,
  name,
  level,
  isOpen,
  isFolder,
  items,
  badge,
  setOpen,
  selected,
}: Props) => (
  <S.StyledLink
    to={to}
    iscat={level === 0 ? 0 : 1}
    isopen={isOpen ? 1 : 0}
    style={{
      paddingLeft: level > 1 ? (level * 28) - 14 : 14,
    }}
    className={selected ? 'selected' : 'default'}
  >
    <ItemIcon
      icon={icon}
      level={level}
      isFolder={isFolder}
      selected={selected}
    />
    <S.Name>{name}</S.Name>
    {badge && <S.Badge>{badge}</S.Badge>}

    {!!items && (
      <S.Arrow
        isOpen={isOpen}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setOpen(!isOpen);
        }}
      />
    )}
  </S.StyledLink>
);

SidebarItem.defaultProps = {
  icon: null,
  level: 0,
};

export default SidebarItem;
